import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Location } from '@angular/common';
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { KeycloakAuthService } from "../auth/_services/keycloak-auth.service";

const base_url = environment.ConfigEndpoints['configuration_url'];
@Injectable()
export class GenericHandlerService {



    constructor(private http: HttpClient, private location: Location, private keycloakAuthService: KeycloakAuthService) {
    }

    /**
     * GET handler
     * @param url
     */
    getCall(url: string, headers: any) {
        return this.http.get(url, { headers: this.toHttpHeaders(headers), observe: 'response' })
            .pipe(map((response: any) => { return { response: response.body, headers: response.headers }; }));
    }

    /**
     * POST handler
     * @param url
     * @param params
     */
    postCall(url: string, params: string, headers: any) {
        return this.http.post<any>(url, params, { headers: this.toHttpHeaders(headers) });
    }

    /**
     * POST handler for image uplaod
     * @param url
     * @param body
     * @param headers
     * @returns
     */
    postImageCall(url: string, body: Blob, headers: any) {
        return this.http.post<any>(url, body, { headers: this.toHttpHeaders(headers) });
    }

    /**
     * POST handler
     * @param url
     * @param params
     */
    postNoBodyCall(url: string, headers: any) {
        return this.http.post<any>(url, null, { headers: this.toHttpHeaders(headers) });
    }

    /**
     * POST handler
     * @param url
     * @param params
     */
    postFormDataCall(url: string, formData: FormData, headers: any) {
        return this.http.post<any>(url, formData, { headers: this.toHttpHeaders(headers) });
    }

    /**
     * DELETE handler
     * @param url
     */
    deleteCall(url: string, headers: any) {
        return this.http.delete<any>(url, { headers: this.toHttpHeaders(headers) });
    }

    /**
     * DELETE handler
     * @param url
     */
    deleteEmptyResponseCall(url: string, headers: any) {
        return this.http.delete<any>(url, { headers: this.toHttpHeaders(headers) }).pipe(map(() => null));
    }


    /**
     * PUT handler
     * @param url
     * @param params
     */
    putCall(url: string, params: string, headers: any) {
        return this.http.put<any>(url, params, { headers: this.toHttpHeaders(headers) });
    }

    // Create base headers
    baseHeaders() {
        return this.keycloakAuthService.buildHeaders();
    }

    // Create headres with content type and CORS
    buildHeaders(content_type: string = null) {
        return this.keycloakAuthService.buildHeaders((content_type) ? content_type : "application/json");

    }

    generalHeaderApi() {
        var currentUser = this.keycloakAuthService.getCurrentUser();
        let headers: any = {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${currentUser.token}`
        };
        if (currentUser.consumer_name) headers["X-Dashboard-Account"] = currentUser.consumer_name;
        if (currentUser.credential_username) headers["X-Caligoo-Username"] = currentUser.credential_username;

        return this.http.get(`${base_url}location`, { headers: this.toHttpHeaders(headers), withCredentials: true })
            .pipe(map((locations: any) => {
                localStorage.setItem('locs', JSON.stringify(locations));
            }), catchError(this.handleError));
    }

    private handleError(error: any) {
        return throwError(() => (error.error && error.error.message) || error.message || 'Server Error');
    }

    private toHttpHeaders(headers: any): HttpHeaders {
        return headers instanceof HttpHeaders ? headers : new HttpHeaders(headers || {});
    }


}
